<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label"
        append-icon="mdi-calendar"
        readonly
        v-bind="{ ...attrs, ...$attrs }"
        v-on="on"
      >
      </v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)"> Accept </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { getFormattedDate } from "@/utils/functions";

export default {
  name: "DatePicker",
  props: {
    value: {
      type: [String, Object],
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      date: this.value ?? getFormattedDate(new Date()),
      menu: false,
    };
  },
  watch: {
    date(value) {
      if (!value) {
        this.$emit("input", null);
        return;
      }
      this.$emit("input", getFormattedDate(value));
    },
    value(value) {
      this.date = value ?? getFormattedDate(new Date());
    },
  },
};
</script>
